import AsyncContent from "@magicware/dashboard/AsyncContent";
import { useProjectSetupId } from "../../navigation/projectSetups";
import { useAppDispatch, useAppSelectorEnsure, useAutoDispatchAsyncThunk } from "../../redux/hooks";
import { projectSetupThunks } from "../../redux/projectSetups/projectSetupsReducer";
import { projectSetupsApi, toUpdate } from "../../services/api/projectSetups";
import { buildForm } from "@magicware/forms/builder";
import * as yup from "yup";
import { updateDetail } from "../../redux/projectSetups/projectSetupsReducer";
import { ProjectSetupModelDetail } from "../../services/api/projectSetups";
import Form from "@magicware/forms/components/Form";
import Panel from "@magicware/dashboard/Panel";
import FormGrid from "@magicware/forms/components/FormGrid";
import { FormParametersAutocomplete } from "../parameters/FormParametersAutocomplete";
import { useTranslation } from "react-i18next";

export const projectParametersForm = buildForm<ProjectSetupModelDetail>()(() => ({
    props: {
        pick: ["parameterList", "excludedParameterList"],
        remove: [],
        extra: [],
    },
    transformations: {
        toForm: { fromModel: (h, m: ProjectSetupModelDetail) => h.fromModel(m) },
        formTo: {
            update: (h, f, m: ProjectSetupModelDetail) => ({
                ...toUpdate(m),
                ...h.toUpdateEntity(f, m),
            }),
        },
    },
    updateReduxModel: updateDetail,
    schema: {
        parameterList: yup.array().default([]),
        excludedParameterList: yup.array().default([]),
    },
}));

const f = projectParametersForm.f;

export default function ProjectSetupParametersTab() {
    const api = useAutoDispatchAsyncThunk(projectSetupThunks.load, useProjectSetupId());
    return <AsyncContent {...api} component={ProjectSetupParametersTabLoaded} />;
}

function ProjectSetupParametersTabLoaded() {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const projectSetupDetail = useAppSelectorEnsure((state) => state.projectSetups.detail);
    const initialValues = projectParametersForm.hooks.useToFormFromModel(projectSetupDetail);
    const onSubmit = async (form: typeof projectParametersForm.f) => {
        const result = await projectSetupsApi.forms.update(
            projectParametersForm.transform.formTo.update(form, projectSetupDetail),
        );
        return projectParametersForm.apiUtils.handleUpdateEntityResult(dispatch, result, form);
    };
    return (
        <Form
            validationSchema={projectParametersForm.validationSchema}
            onSubmit={onSubmit}
            initialValues={initialValues}
            savePanel={{ successMessage: t("project-has-been-saved") }}
        >
            <Panel>
                <FormGrid>
                    <FormParametersAutocomplete
                        f={f}
                        field="parameterList"
                        fullOption
                        multiple
                        label={t("parameters-label")}
                        filter={{}}
                    />
                    <FormParametersAutocomplete
                        f={f}
                        field="excludedParameterList"
                        fullOption
                        multiple
                        label={t("excluded-parameters-label")}
                        filter={{}}
                    />
                </FormGrid>
            </Panel>
        </Form>
    );
}
